<template>
	<div>
		<org-chart />
	</div>
</template>

<script>
	import OrgChart from '@/components/OrgChart';

	export default {
		components: {
			OrgChart
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Org Chart');
		},
	};
</script>

<style></style>
